import { lazy } from "react";

export enum ContractPath {
  invitation = "invitation",
  contract = "contract",
  type = "type",
  aboutPayment = "aboutPayment",
  typePayment = "typePayment",
  typePaymentRequirement = "typePaymentRequirement",
  membershipUpgrade = "membershipUpgrade",
  loginCallback = "loginCallback",
  attachments = "attachments",
  trialMembership = "trialMembership",
  insurance = "insurance",
  preview = "preview",
  sign = "sign",
  signingMethodUpgradeContract = "signingMethodUpgradeContract",
  signCallback = "signCallback",
  status = "status",
  settlement = "settlement",
  confirmationLanding = "confirmationLanding",
  waitingForPdf = "waitingForPdf",
  summary = "summary",
  financialConfirmation = "financialConfirmation",
  postConfirmationTrialMembership = "postConfirmationTrialMembership",
  postConfirmationInsurance = "postConfirmationInsurance",
}

export const CONTRACT_PATH_ROUTES: {
  [path in ContractPath]: {
    path: string;
    progress: number;
    component: React.ComponentType;
  };
} = {
  [ContractPath.loginCallback]: {
    path: "/kontrakt/innlogging",
    progress: 0,
    component: lazy(() => import("../contract-type/ContractLoginCallbackPage")),
  },
  [ContractPath.invitation]: {
    path: "/invitasjon",
    progress: 0.05,
    component: lazy(() => import("../invitation/InvitationLandingPage")),
  },
  [ContractPath.contract]: {
    path: "/kontrakt",
    progress: 0.1,
    component: lazy(() => import("../fields/FieldsPage")),
  },
  [ContractPath.aboutPayment]: {
    path: "/om-betaling",
    progress: 0.2,
    component: lazy(() => import("../fields/AboutPaymentPage")),
  },
  [ContractPath.type]: {
    path: "/velg-type",
    progress: 0.25,
    component: lazy(() => import("../contract-type/ContractTypePage")),
  },
  [ContractPath.membershipUpgrade]: {
    path: "/oppgrader/medlem",
    progress: 0.275,
    component: lazy(() => import("../contract-type/MembershipUpgradePage")),
  },
  [ContractPath.typePaymentRequirement]: {
    path: "/oppgrader/:contractType/info",
    progress: 0.275,
    component: lazy(() => import("../contract-type/UpgradeContractPage")),
  },
  [ContractPath.typePayment]: {
    path: "/oppgrader/betaling",
    progress: 0.275,
    component: lazy(
      () => import("../contract-type/ContractTypePaymentProcessingPage")
    ),
  },
  [ContractPath.attachments]: {
    path: "/vedlegg",
    progress: 0.3,
    component: lazy(() => import("../attachments/AttachmentsPage")),
  },
  [ContractPath.trialMembership]: {
    path: "/provemedlemskap",
    progress: 0.4,
    component: lazy(() => import("../trial-membership/TrialMembershipPage")),
  },
  [ContractPath.insurance]: {
    path: "/forsikring",
    progress: 0.55,
    component: lazy(() => import("../insurance/InsurancePage")),
  },
  [ContractPath.preview]: {
    path: "/forhandsvisning",
    progress: 0.675,
    component: lazy(() => import("../preview/PreviewPage")),
  },
  [ContractPath.sign]: {
    path: "/signer/:hash",
    progress: 0.8,
    component: lazy(() => import("../singing/SigningPage")),
  },
  [ContractPath.signingMethodUpgradeContract]: {
    path: "/bankid/oppgrader-kontrakt",
    progress: 0.875,
    component: lazy(
      () => import("../contract-type/SigningMethodUpgradeContractPage")
    ),
  },
  [ContractPath.signCallback]: {
    path: "/signer/:hash/callback",
    progress: 0.8,
    component: lazy(() => import("../singing/SigningCallbackPage")),
  },
  [ContractPath.status]: {
    path: "/status",
    progress: 0.9,
    component: lazy(() => import("../status/StatusPage")),
  },
  [ContractPath.confirmationLanding]: {
    path: "/bekreftelse",
    progress: 1,
    component: lazy(() => import("../confirmation/ConfirmationLandingPage")),
  },
  [ContractPath.confirmationLanding]: {
    path: "/bekreftelse",
    progress: 1,
    component: lazy(() => import("../confirmation/ConfirmationLandingPage")),
  },
  [ContractPath.waitingForPdf]: {
    path: "/bekreftelse/pdf",
    progress: 1,
    component: lazy(() => import("../confirmation/ConfirmationLandingPage")),
  },
  [ContractPath.summary]: {
    path: "/bekreftelse/oppsummering",
    progress: 1,
    component: lazy(() => import("../confirmation/ConfirmationLandingPage")),
  },
  [ContractPath.settlement]: {
    path: "/bekreftelse/oppgjor",
    progress: 0.95,
    component: lazy(() => import("../confirmation/ConfirmationLandingPage")),
  },
  [ContractPath.financialConfirmation]: {
    path: "/bekreftelse/betaling",
    component: lazy(() => import("../confirmation/FinancialPage")),
    progress: 1,
  },
  [ContractPath.postConfirmationTrialMembership]: {
    path: "/bekreftelse/provemedlemskap",
    component: lazy(
      () => import("../confirmation/PostConfirmationTrialMembershipPage")
    ),
    progress: 1,
  },
  [ContractPath.postConfirmationInsurance]: {
    path: "/bekreftelse/forsikring",
    component: lazy(
      () => import("../insurance/PostConfirmationCarInsurancePage")
    ),
    progress: 1,
  },
};
